import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class ProductCarouselToggle {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.slideToggles = document.querySelectorAll('.js-slides-toggle');
        this.slideToggleAll = document.querySelector('.js-slides-all');
        this.slides = this.sliderElement.querySelectorAll('.js-slide');
        this.init()
    }

    init() {
        const swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            pagination: {
                el: this.pagination
            },
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                }
            }
        });

        // Click event for all slides toggle
        if (this.slideToggleAll) {
            this.slideToggleAll.addEventListener('click', () => {
                const collectionSliderElements = this.sliderElement.querySelector('.collections-slider');
                const collectionAllElements = this.sliderElement.querySelector('.all-slider');

                if (collectionSliderElements) {
                    collectionSliderElements.classList.add('!hidden');
                    const elementsCollection = collectionSliderElements.querySelectorAll('.swiper-slide');
                    elementsCollection.forEach(element => {
                        element.classList.add('hidden');
                    });
                }

                if (collectionAllElements) {
                    collectionAllElements.classList.remove('!hidden');
                    const elementsAll = collectionAllElements.querySelectorAll('.swiper-slide');
                    elementsAll.forEach(element => {
                        element.classList.remove('hidden');
                    });
                }

                // Add active classes to all button
                this.slideToggleAll.classList.add('button--pink');
                
                // Remove active classes from other buttons
                this.slideToggles.forEach(button => {
                    button.classList.remove('button--pink');
                })

                // Slide to start when slides change
                swiper.slideTo(0);
                swiper.scrollbar.setTranslate(0);
                swiper.update()
            });
        }

        if (this.slideToggles) {
            this.slideToggles.forEach(button => {
                // Click event for slide toggles other than 'All'
                button.addEventListener('click', () => {

                    const collectionSliderElements = this.sliderElement.querySelector('.collections-slider');
                    const collectionAllElements = this.sliderElement.querySelector('.all-slider');
                    if(collectionSliderElements) {
                        collectionSliderElements.classList.remove('!hidden');
                    }
                    if(collectionAllElements) {
                        collectionAllElements.classList.add('!hidden');
                    }

                    const buttonType = button.dataset.type;
                    this.slides.forEach(slide => {
                        const slideType = slide.dataset.type;
                        if(buttonType == slideType) {
                            slide.classList.remove('hidden');
                        } else {
                            slide.classList.add('hidden');
                        }

                        if (slide.classList.contains('js-all-slider-slides')){
                            slide.classList.add('hidden');
                        }
                    });
    
                    // Slide to start when slides change
                    swiper.slideTo(0);
                    swiper.scrollbar.setTranslate(0);
                    swiper.update()
    
                    // Remove active buttton classes from all
                    this.slideToggleAll.classList.remove('button--pink');
    
                    // Remove from all buttons on click
                    this.slideToggles.forEach(button => {
                        button.classList.remove('button--pink');
                    })
    
                    // Add active classes to current button
                    button.classList.add('button--pink');
                });
            });
        }
    }
}
